function __tydeHome(){
  var stage=document.getElementById('th-orb'), marea=document.getElementById('th-marea');
  if(!stage||!marea) return;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var LOGO_D=marea.getAttribute('d');              // bézier ESATTO del marchio (sagoma-marea = logo standard)
  var OX=579, OY=536, VB0=-60, VBW=1200;           // centro = centro del disco; viewBox -60 -60 1200 1200
  var disc=document.getElementById('th-disc');
  var vessel=document.getElementById('th-vessel'), dot=document.getElementById('th-dot');   // v4.4: cursore-puntino (marea del brand)
  var N=360, DEG=Math.PI/180;
  function shortest(a){ a=((a+180)%360+360)%360-180; return a; }
  // --- profili radiali REALI (dal centro O): contorno esterno per angolo (sagoma star-convex) ---
  function measure(path){
    var L=path.getTotalLength(), S=3000, rad=new Array(N), k; for(k=0;k<N;k++) rad[k]=0;
    for(var t=0;t<=S;t++){ var p=path.getPointAtLength(L*t/S), dx=p.x-OX, dy=p.y-OY;
      var a=Math.atan2(dy,dx)/DEG; a=((a%360)+360)%360; var i=Math.round(a)%N, r=Math.sqrt(dx*dx+dy*dy); if(r>rad[i]) rad[i]=r; }
    for(k=0;k<N;k++){ if(rad[k]===0){ var j=1; while(j<N && rad[(k-j+N)%N]===0 && rad[(k+j)%N]===0) j++; rad[k]=rad[(k-j+N)%N]||rad[(k+j)%N]||1; } }
    return rad;
  }
  var RLOGO=measure(marea), RDISC=disc?measure(disc):RLOGO.map(function(v){return v-24;});
  var maxDisc=0, mm; for(mm=0;mm<N;mm++) if(RDISC[mm]>maxDisc) maxDisc=RDISC[mm];
  // CRESTA ACCENTUATA = angolo di massimo raggio; RCIRC = "livello del mare" = raggio MINIMO (cerchio equidistante)
  var CREST=0, c1; for(c1=0;c1<N;c1++) if(RLOGO[c1]>RLOGO[CREST]) CREST=c1;
  var RCIRC=Infinity, r0; for(r0=0;r0<N;r0++) if(RLOGO[r0]<RCIRC) RCIRC=RLOGO[r0];   // ≈341.8 ≥ maxDisco 329 ⇒ no leak
  // EXCESS = profilo-logo − cerchio: contiene ENTRAMBE le punte (accentuata a CREST + morbida opposta)
  var EXCESS=new Array(N), e0; for(e0=0;e0<N;e0++) EXCESS[e0]=Math.max(0, RLOGO[e0]-RCIRC);
  // R(φ)=RCIRC + A·EXCESS(φ−(θ−CREST)). A=0 ⇒ cerchio; A=1,θ=CREST ⇒ RLOGO (logo esatto). No leak: R≥RCIRC≥maxDisco.
  function shapeD(A, thetaDeg){
    var shift=thetaDeg-CREST, d='M', i, sf,i0,fr,ex,R,x,y;
    for(i=0;i<N;i++){
      sf=i-shift; i0=Math.floor(sf); fr=sf-i0;
      ex=EXCESS[((i0%N)+N)%N]*(1-fr)+EXCESS[(((i0+1)%N)+N)%N]*fr;
      R=RCIRC+A*ex;
      x=OX+Math.cos(i*DEG)*R; y=OY+Math.sin(i*DEG)*R;
      d+=(i?'L':'')+x.toFixed(2)+','+y.toFixed(2);
    }
    return d+'Z';
  }
  // --- MANOPOLE ---
  var SMOOTH=0.60;                                  // morbidezza/inerzia (s) durante l'inseguimento: più alto = più "mare", più lag
  var SMOOTH_RETURN=1.5;                             // v4.4: RITORNO al logo (all'uscita dalla card) — più LENTO/dolce dell'inseguimento (manopola __tide.settle)
  var DEADR=0.30, SATR=1.10;                         // curva distanza→ampiezza: raggio MORTO (dentro→A=0, marea SPARITA) e distanza di saturazione (=logo), frazioni di r.width
  function ampFromDist(dist, rw){ var x=(dist/rw - DEADR)/(SATR-DEADR); x=Math.max(0,Math.min(1,x)); return x*x*(3-2*x); } // smoothstep, =0 esatto entro DEADR
  // --- STATO: la cresta è un VETTORE (vx,vy)=ampiezza·direzione, smorzato per-componente (retract-and-reform) ---
  var LX=Math.cos(CREST*DEG), LY=Math.sin(CREST*DEG);   // vettore-logo (ampiezza 1 verso CREST = logo standard)
  var VX={p:LX,v:0}, VY={p:LY,v:0};                     // stato corrente
  var tvx=LX, tvy=LY, engaged=false, raf=0, lastT=0;
  function damp(o, tgt, dt, sm){                        // SmoothDamp scalare (critico-smorzato, no overshoot)
    if(dt<=0) return;
    var omega=2/(sm||SMOOTH), x=omega*dt, exp=1/(1+x+0.48*x*x+0.235*x*x*x);
    var change=o.p-tgt, temp=(o.v+omega*change)*dt;
    o.v=(o.v-omega*temp)*exp; o.p=tgt+(change+temp)*exp;
  }
  function render(){
    var A=Math.min(1, Math.hypot(VX.p,VY.p)), theta=Math.atan2(VY.p,VX.p)/DEG;
    if(!engaged && Math.abs(A-1)<0.01 && Math.abs(shortest(theta-CREST))<0.6){ marea.setAttribute('d', LOGO_D); }  // riposo: logo ESATTO
    else { marea.setAttribute('d', shapeD(A, theta)); }
  }
  function onMove(cx, cy){
    if(reduce) return;
    var r=stage.getBoundingClientRect();
    var ox=r.left + r.width*((OX-VB0)/VBW), oy=r.top + r.height*((OY-VB0)/VBW);
    var dx=cx-ox, dy=cy-oy, dist=Math.sqrt(dx*dx+dy*dy);
    if(dist < r.width*1.55){                            // cursore sul/vicino al canvas: interazione attiva
      var ang=Math.atan2(dy,dx), A=ampFromDist(dist, r.width);   // CENTRO/VICINO→0 (marea SPARISCE = cerchio), LONTANO→1 (=logo)
      tvx=A*Math.cos(ang); tvy=A*Math.sin(ang); engaged=true;
    } else { tvx=LX; tvy=LY; engaged=false; }           // fuori: torna morbido al logo standard (punta accentuata basso-sx)
    kick();
  }
  function step(ts){
    var dt=lastT?Math.min(0.05,(ts-lastT)/1000):1/60; lastT=ts;   // dt reale (frame-rate independent), clamp su tab inattivo
    var sm=engaged?SMOOTH:SMOOTH_RETURN;                          // v4.4: uscito dalla card ⇒ ritorno LENTO/dolce al logo
    damp(VX,tvx,dt,sm); damp(VY,tvy,dt,sm);
    render();
    var da=Math.hypot(VX.p-tvx, VY.p-tvy), dv=Math.hypot(VX.v,VY.v);
    if(da<0.002 && dv<0.02){ VX.p=tvx; VY.p=tvy; VX.v=VY.v=0; render(); raf=0; lastT=0; return; }
    raf=requestAnimationFrame(step);
  }
  function kick(){ if(reduce){ VX.p=tvx; VY.p=tvy; VX.v=VY.v=0; render(); return; } if(!raf){ lastT=0; raf=requestAnimationFrame(step); } }

  if(vessel && !matchMedia('(hover:none)').matches){
    vessel.addEventListener('pointermove', function(e){ if(e.pointerType&&e.pointerType!=='mouse') return; onMove(e.clientX, e.clientY); });  // marea (v4.1 intatto)
    vessel.addEventListener('pointerleave', function(){ tvx=LX; tvy=LY; engaged=false; kick(); });                                            // marea si riassesta piano al logo
  }

  (function(){
    if(!dot) return;
    var ZONES='.th-vessel,.th-path,.th-case,.th-step';
    var px=-100, py=-100, curS=1, tgtS=1, active=false, praf=0;
    function loop(){
      curS += (tgtS-curS) * (reduce?1:0.28);                          // crescita/rientro fluido senza CSS transition (niente conflitto col transform)
      if(Math.abs(tgtS-curS)<0.002) curS=tgtS;
      dot.style.transform='translate3d('+px+'px,'+py+'px,0) scale('+curS.toFixed(3)+')';
      praf = active ? requestAnimationFrame(loop) : 0;
    }
    function activate(clickable){
      tgtS = clickable ? 1.34 : 1;                                    // micro-stato «cliccabile» = crescita discreta
      dot.classList.toggle('clickable', !!clickable);
      if(!active){ active=true; dot.classList.add('on'); }
      if(!praf) praf=requestAnimationFrame(loop);
    }
    function deactivate(){ if(active){ active=false; dot.classList.remove('on','clickable'); tgtS=1; } }
    document.addEventListener('pointermove', function(e){
      if(e.pointerType && e.pointerType!=='mouse'){ deactivate(); return; }   // solo mouse: touch/pen → cursore nativo, nessun puntino
      var root=document.documentElement; if(!root.classList.contains('tyde-cur')) root.classList.add('tyde-cur'); // ora il cursore nativo è nascosto sulle zone
      px=e.clientX; py=e.clientY;
      var t=e.target, zone=t&&t.closest?t.closest(ZONES):null;
      if(zone){ activate(!!(t.closest('a[href],button'))); }         // card = stretched-link ⇒ cliccabile; step = no ⇒ piano
      else{ deactivate(); }
    }, {passive:true});
    document.documentElement.addEventListener('mouseleave', deactivate);   // il puntatore lascia la finestra → nascondi
    window.addEventListener('blur', deactivate);
  })();
  /* MOBILE / TOUCH: nessun cursore ⇒ la marea si muove DA SOLA (marea autonoma).
     Ampiezza e cresta oscillano in perpetuo attorno al logo («un ciclo che non si
     ferma»). Copre sempre il disco (R>=RCIRC>=maxDisco). reduced-motion ⇒ logo fermo;
     si mette in pausa a scheda nascosta (batteria). Desktop invariato. */
  if(matchMedia('(hover:none)').matches){
    var _hint=vessel?vessel.querySelector('.hint'):null; if(_hint) _hint.style.display='none';
    if(reduce){ tvx=LX; tvy=LY; engaged=false; }
    else{
      var _amRaf=0, _amT0=0;
      var _amb=function(ts){
        if(!_amT0) _amT0=ts; var t=(ts-_amT0)/1000;
        var ang=(CREST + 34*Math.sin(t*0.55) + 12*Math.sin(t*0.23+0.7))*DEG;
        var amp=0.84 + 0.16*Math.sin(t*0.68+1.1);
        VX.p=amp*Math.cos(ang); VY.p=amp*Math.sin(ang); VX.v=VY.v=0; engaged=true;
        render();
        _amRaf=requestAnimationFrame(_amb);
      };
      var _amStart=function(){ if(!_amRaf) _amRaf=requestAnimationFrame(_amb); };
      var _amStop=function(){ if(_amRaf){ cancelAnimationFrame(_amRaf); _amRaf=0; } };
      document.addEventListener('visibilitychange', function(){ document.hidden?_amStop():_amStart(); });
      _amStart();
    }
  }
  render();  // riposo: logo esatto (bézier), punta accentuata basso-sinistra

  var burger=document.getElementById('te-burger'), mnav=document.getElementById('te-mnav');
  if(burger&&mnav){
    burger.addEventListener('click', function(){
      var open=burger.getAttribute('aria-expanded')==='true';
      burger.setAttribute('aria-expanded', String(!open));
      burger.setAttribute('aria-label', open?'Apri il menu':'Chiudi il menu');
      mnav.classList.toggle('open', !open);
    });
    Array.prototype.forEach.call(mnav.querySelectorAll('a'), function(a){
      a.addEventListener('click', function(){
        burger.setAttribute('aria-expanded','false');
        burger.setAttribute('aria-label','Apri il menu');
        mnav.classList.remove('open');
      });
    });
  }

  // area della sagoma ricostruita a (A,θ): shoelace polare = 0.5·Σ R_i·R_{i+1}·sin(1°)
  function Rradius(A, thetaDeg, k){ var shift=thetaDeg-CREST, sf=k-shift, i0=Math.floor(sf), fr=sf-i0;
    var ex=EXCESS[((i0%N)+N)%N]*(1-fr)+EXCESS[(((i0+1)%N)+N)%N]*fr; return RCIRC+A*ex; }
  function areaOf(A, thetaDeg){ var S=0, i, r1,r2;
    for(i=0;i<N;i++){ r1=Rradius(A,thetaDeg,i); r2=Rradius(A,thetaDeg,(i+1)%N); S+=r1*r2; } return Math.round(0.5*S*Math.sin(DEG)); }
  function simulate(){ for(var q=0;q<3000;q++){ damp(VX,tvx,1/60); damp(VY,tvy,1/60); } VX.p=tvx; VY.p=tvy; VX.v=VY.v=0; render(); }
  window.__tide={
    // aim(deg, amp): cursore in direzione deg con ampiezza amp (default 1 = lontano/pieno; 0 = piatto)
    aim:function(deg, amp){ if(amp==null) amp=1; var rad=((deg%360)+360)%360*DEG; tvx=amp*Math.cos(rad); tvy=amp*Math.sin(rad); engaged=true; kick(); },
    flat:function(){ tvx=0; tvy=0; engaged=true; kick(); },                       // mare piatto (cursore vicino)
    smooth:function(v){ if(v!=null) SMOOTH=Math.max(0.05,+v); return SMOOTH; },    // manopola morbidezza
    dist:function(dead,sat){ if(dead!=null) DEADR=+dead; if(sat!=null) SATR=+sat; return {DEADR:DEADR,SATR:SATR}; }, // manopola curva distanza→ampiezza
    // v4.4 — manopola PUNTINO: dot(larghezzaPx, opacità 0..1) — mantiene il rapporto del glyph-marea
    dot:function(sizePx, op){ if(!dot) return null; if(sizePx!=null){ var s=Math.max(6,+sizePx), h=Math.round(s*14/16); dot.style.width=s+'px'; dot.style.height=h+'px'; dot.style.margin=(-h/2)+'px 0 0 '+(-s/2)+'px'; } if(op!=null) dot.style.setProperty('--dot-op', Math.max(0,Math.min(1,+op))); return {w:dot.offsetWidth, h:dot.offsetHeight, op:getComputedStyle(dot).getPropertyValue('--dot-op')||'1'}; },
    // settle(sec): se passi sec → imposta la MORBIDEZZA del RITORNO al logo (uscita card); senza arg → riporta lo stato assestato
    settle:function(sec){ if(sec!=null){ SMOOTH_RETURN=Math.max(0.05,+sec); return {settle_return:SMOOTH_RETURN}; } simulate(); return {ampiezza:+Math.min(1,Math.hypot(VX.p,VY.p)).toFixed(3), direzione:Math.round(((Math.atan2(VY.p,VX.p)/DEG)%360+360)%360), crest:CREST, smooth:SMOOTH, settle_return:SMOOTH_RETURN}; },
    rest:function(){ tvx=LX; tvy=LY; engaged=false; simulate(); return marea.getAttribute('d')===LOGO_D ? 'LOGO-ESATTO' : 'attivo'; },

    area:function(){
      var rmin=1e9, rmax=0, k; for(k=0;k<N;k++){ var r=Rradius(0,CREST,k); if(r<rmin)rmin=r; if(r>rmax)rmax=r; }
      return {
        logo_esatto:areaOf(1,CREST),
        pieno_alto:areaOf(1,270), pieno_destra:areaOf(1,0), pieno_sinistra:areaOf(1,180),
        cerchio_piatto:areaOf(0,CREST),
        flat_spread_raggi:+(rmax-rmin).toFixed(3), RCIRC:+RCIRC.toFixed(1), maxDisco:+maxDisc.toFixed(1), margine_noleak:+(RCIRC-maxDisc).toFixed(1),
        crest:CREST }; },

    crossMinAmp:function(){ tvx=1;tvy=0;engaged=true; simulate(); tvx=-1;tvy=0; var minA=9;
      for(var q=0;q<3000;q++){ damp(VX,tvx,1/60); damp(VY,tvy,1/60); var A=Math.hypot(VX.p,VY.p); if(A<minA)minA=A; if(Math.hypot(VX.p-tvx,VY.p-tvy)<0.002)break; }
      VX.p=tvx;VY.p=tvy;VX.v=VY.v=0; render(); return {min_ampiezza_nel_passaggio:+minA.toFixed(3)}; }
  };
}
function __tydeBoot(){
  try{ var m=document.getElementById('th-marea'); if(m && m.getTotalLength && m.getTotalLength()>0){ __tydeHome(); return; } }catch(e){}
  requestAnimationFrame(__tydeBoot);
}
if(document.readyState!=='loading'){ __tydeBoot(); } else { document.addEventListener('DOMContentLoaded', __tydeBoot); }
